import * as TP from '../subscriptionTypes';

import { gql } from '@apollo/client';
export type RecalculateMileageEventPayloadFragment = (
  { readonly __typename?: 'RecalculateMileageEvent' }
  & Pick<TP.RecalculateMileageEvent, 'id' | 'orderId' | 'correlationId' | 'mileageType'>
  & { loadIdentifier: TP.RecalculateMileageEvent['loadId'], routeIdentifier: TP.RecalculateMileageEvent['routeId'] }
);

export const RecalculateMileageEventPayloadFragmentDoc = gql`
    fragment RecalculateMileageEventPayload on RecalculateMileageEvent {
  id
  loadIdentifier: loadId
  orderId
  routeIdentifier: routeId
  correlationId
  mileageType
}
    `;